import React, { Ref, useEffect, useRef } from 'react';
import { FlatList, StyleSheet, Text } from 'react-native';
import PressableStyled from '../../../components/PressableStyled';
import Colors from '../../../constants/Colors';

interface MetricSelectionRowProps {
  titles: string[],
  selectedTitle: string,
  select,
}

const MetricSelectionRow = ({
  titles, selectedTitle, select,
}: MetricSelectionRowProps) => {
  const listRef: Ref<FlatList | null> = useRef<FlatList | null>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      listRef?.current?.scrollToIndex({
        index: titles.indexOf(selectedTitle),
        viewPosition: 0.5,
      });
      clearTimeout(timeout);
    }, 250);
  }, [selectedTitle]);

  return <FlatList
    ref={listRef}
    horizontal
    style={styles.container}
    contentContainerStyle={styles.content}
    data={titles}
    onScrollToIndexFailed={() => { }}
    renderItem={({ item: title, index }) => {
      const selected: boolean = title === selectedTitle;
      return <PressableStyled
        style={[styles.item, selected && styles.itemSelected]}
        onPress={() => select(index)}
        disabled={selected}
        maintainOpacityWhenDisabled
      >
        <Text style={[styles.text, selected && styles.textSelected]}>{title}</Text>
      </PressableStyled>;
    }}
    keyExtractor={(title: string) => `metric_button_${title}`}
  />;
};

const styles = StyleSheet.create({
  container: {
    marginTop: 16,
    marginHorizontal: -16,
    marginBottom: -16,
    borderTopWidth: 1.5,
    borderTopColor: Colors.light.hereworksWhite500,
  },
  content: {
    paddingTop: 12,
    paddingBottom: 16,
    paddingStart: 16,
    paddingEnd: 8,
  },
  item: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksWhite500,
    marginEnd: 8,
  },
  itemSelected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderWidth: 0,
  },
  text: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
  textSelected: {
    color: '#FFF',
  },
});

export default MetricSelectionRow;
